// extracted by mini-css-extract-plugin
module.exports = {"trustedRetailerBanner":"Sw-z","trustedRetailerTooltipWrapper":"Tw-z"};